import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-normalArrow",
  "use": "icon-normalArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-normalArrow\"><path d=\"M235.536 962l-168.118-285.23 37.373-16.678c2.070-0.852 200.622-91.425 483.538-337.333l-86.555-89.963 454.808-170.797-160.692 476.6-73.163-76.085c-161.422 203.665-441.417 458.095-453.957 469.417l-33.234 30.069zM171.015 708.666l81.685 138.658c85.46-79.615 315.785-298.986 437.522-462.6l25.686-34.573 49.059 51.129 73.043-216.692-206.709 77.668 62.451 64.886-28.365 25.199c-237.752 211.213-419.871 317.245-494.374 356.323z\" p-id=\"10795\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/normalArrow.svg
// module id = fPUf
// module chunks = 12